exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit[data-v-5380efc8] {\n  cursor: text;\n  color: #fff;\n}\n.text-area[data-v-5380efc8] {\n  width: 404px;\n  min-height: 55px;\n  height: auto;\n  resize: vertical;\n}\n", ""]);

// exports
